module.exports = __webpack_public_path__ + "img/Slice 268@2x(5).e60a0a3d.png";